module.exports = __webpack_public_path__ + "img/BLANCO_Learning.27cf0966.png";